import PropTypes from 'prop-types';

import { getPromptPillValue } from '@helpers';
import { CloseBoldIcon, OverlayTriggerTooltip, truncateTextWithEllipsis } from '@utilities';
import styles from './_index.module.scss';

const SelectedAnswers = ({ activePrompt, setSelectedAnswers, transformedAnswersMap }) => {
  const promptKey = activePrompt?.promptKey;
  const currentAnswers = transformedAnswersMap?.[promptKey];

  if (!currentAnswers || currentAnswers.length === 0) {
    return null;
  }

  const flattenedValues = currentAnswers.flatMap((group) => group.values);

  const handleRemoveAnswer = ({ answerId }) => {
    setSelectedAnswers((prev) => ({
      ...prev,
      [promptKey]: prev[promptKey].filter(({ id }) => id !== answerId),
    }));
  };

  return (
    <ul className={styles['selected-answers']}>
      {flattenedValues?.map((answer, index) => {
        const value = getPromptPillValue({
          answers: { [activePrompt?.id]: [answer] },
          prompt: activePrompt,
        });
        const truncatedValue = truncateTextWithEllipsis({
          length: 18,
          text: getPromptPillValue({
            answers: { [activePrompt?.id]: [answer] },
            prompt: activePrompt,
          }),
        });

        return (
          <li key={`selected-answers-${index}`}>
            <OverlayTriggerTooltip content={value} isFullWidth>
              <div className={styles['selected-answer-container']}>
                <p className={styles['selected-answer']}>{truncatedValue}</p>
                <CloseBoldIcon onClick={() => handleRemoveAnswer({ answerId: answer.id })} />
              </div>
            </OverlayTriggerTooltip>
          </li>
        );
      })}
    </ul>
  );
};

SelectedAnswers.propTypes = {
  activePrompt: PropTypes.object.isRequired,
  setSelectedAnswers: PropTypes.func.isRequired,
  transformedAnswersMap: PropTypes.object.isRequired,
};

export default SelectedAnswers;
